'use client'

import { useState } from 'react'
import Image from 'next/image'

/**
 * Image with error fallback
 */
export function SafeImage({
  src,
  alt,
  fallbackIcon: FallbackIcon,
  iconClassName,
  ...props
}: {
  src: string
  alt: string
  fallbackIcon: React.ElementType
  iconClassName?: string
} & Omit<React.ComponentProps<typeof Image>, 'src' | 'alt'>) {
  const [hasError, setHasError] = useState(false)

  if (hasError || !src) {
    return (
      <div className="flex h-full items-center justify-center">
        <FallbackIcon className={iconClassName} />
      </div>
    )
  }

  return (
    <Image src={src} alt={alt} onError={() => setHasError(true)} {...props} />
  )
}
